import { DESKTOP } from "@/themes/device";
import styled from "@emotion/styled";
import { grayScale, mHeader1, wHeader2 } from "@teamsparta/design-system";

export const Wrapper = styled.div`
  padding: 80px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${grayScale.gray100};

  ${DESKTOP} {
    padding: 120px 0;
  }
`;

export const MainText = styled.h2`
  ${mHeader1}
  color: ${grayScale.white};
  text-align: center;

  ${DESKTOP} {
    ${wHeader2}
    color: ${grayScale.white};
  }
`;
